import React from 'react'
import { VSLClinicalStudiesData } from '../constant/data'

const ClinicalStudies = ({ onClickSkip }) => {



    return (
        <div className="bg-[#E6E4E0] px-4">
            <div className="max-w-7xl mx-auto py-8">
                <h2 className="text-[#737270] text-lg font-bold py-10 text-center">
                    Supporting Clinical Studies:</h2>

                <div className="grid grid-cols-1 sm:grid-cols-2  md:grid-cols-2 gap-5  pb-10">
                    {VSLClinicalStudiesData.map((ref, index) => (
                        <a
                            key={index}
                            href={ref}
                            className=" font-light text-xs   break-all"
                        >
                            {index + 1}. {ref}
                        </a>
                    ))}
                </div>

                <div className="pt-8 border-t border-black text-xs text-black space-y-4 text-center font-light leading-[18px]">
                    <p>
                        *This site is not a part of the Facebook website or Facebook Inc. Additionally, This site is NOT endorsed by Facebook in any way. FACEBOOK is a trademark of FACEBOOK, Inc. These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease.. The information provided on this site is for informational purposes only and is not intended as a substitute for advice from your physician or other health care professional or any information contained on or in any product label or packaging. You should not use the information on this site for diagnosis or treatment of any health problem or for prescription of any medication or other treatment. You should consult with a healthcare professional before starting any diet, exercise or supplementation program, before taking any medication, or if you have or suspect you might have a health problem.
                    </p>
                    <p>
                        Medical Disclaimer: The content is not intended to be a substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of your physician or another qualified health provider with any questions you may have regarding a medical condition. Seek your doctor's advice before changing or discontinuing any prescription. The information provided on this page is not intended to replace a prescription or any medical treatment. Never disregard professional medical advice or delay in seeking it because of something you have read on this website.
                    </p>

                    <div className='w-full pt-10 text-start text-xs text-black space-y-4'>

                        <p>
                            ClickBank is the retailer of this product. CLICKBANK® is a registered trademark of Click Sales, Inc., a Delaware corporation located at 1444 S. Entertainment Ave., Suite 410 Boise, ID 83709, USA and used by permission. ClickBank’s role as retailer does not constitute an endorsement, approval or review of this product or any claim, statement or opinion used in promotion of this product.
                        </p>
                        <p>
                            Statements on this website have not been evaluated by the Food and Drug Administration. Products are not intended to diagnose, treat, cure or prevent any disease. If you are pregnant, nursing, taking medication, or have a medical condition, consult your physician before using our products.
                        </p>
                        <p>
                            Testimonials, case studies, and examples found on this page are results that have been forwarded to us by users of "scalerespo" products and related products are not intended to represent or guarantee that anyone will achieve the same or similar results.
                        </p>
                        <p>
                            For Product Support, please contact the seller <a href='/contact' className='text-blue-600 hover:underline'>[HERE]</a>
                        </p>
                        <p>
                            For Order Support, please contact ClickBank{" "}

                            <a href='https://www.clkbank.com/' className='text-blue-600 hover:underline'>HERE*</a>
                        </p>
                    </div>


                    <p className="text-center">

                        <span
                            onClick={onClickSkip}

                        >
                            &copy;
                        </span>  {new Date().getFullYear()} Respoclear.net. All Rights Reserved.
                    </p>
                </div>


                <footer className="mt-6 text-center text-sm text-[#000]">
                    <nav className="flex flex-row justify-center space-x-2  font-light">
                        <a href="/privacy" >Privacy Policy</a>
                        <span className="">|</span>
                        <a href="/terms" >Terms</a>
                        <span className="">|</span>
                        <a href="/contact" >Contact</a>
                        <span className="">|</span>
                        <a href="/returns" >Returns</a>
                        <span className="">|</span>
                        <a href="/disclaimer" >Disclaimer</a>
                    </nav>
                </footer>


            </div>
        </div>
    )
}

export default ClinicalStudies

